import { useTranslation } from "react-i18next";
import {
  InviteCodeLabel,
  InviteCodeWrapper,
  Padding,
  ReferralCodeText,
  RememberCheckbox,
  RememberMeTooltipWrapper,
} from "./style";

import { ReactComponent as Info } from "../../assets/svg/info.svg";
import { LocalStorageKeyEnum } from "../../enums/localStorage";
import { SIGNING_KEY_TTL } from "../../constants/session";
import { useCheckReferral } from "../../hooks/api/referrals/useCheckReferral";
import { getAppShortName } from "../../config/chains";
import { ID_TO_CHAINS } from "../../hooks/wallet/useWallet";
import { supportedChainId } from "../../utils/wallet/connectors";
import Checkbox from "../shared/Checkbox";
import { Input } from "../shared/Input";
import { HeaderSubText } from "../shared/SharedModalStyles/styles";
import TooltipExplanation from "../shared/Tooltip";

interface IEnableTradingProps {
  isRememberMeChecked: boolean;
  setRememberMe: (remember: boolean) => void;
  inviteCode?: string;
  setInviteCode?: (code: string) => void;
  inviteRequired?: boolean;
}

function EnableTrading({
  isRememberMeChecked,
  setRememberMe,
  inviteCode,
  setInviteCode,
  inviteRequired,
}: IEnableTradingProps) {
  const referralCode = window.localStorage.getItem(
    LocalStorageKeyEnum.REFERRAL_CODE
  );
  const { data: checkReferralData } = useCheckReferral();
  const { t } = useTranslation("app", {
    keyPrefix: "ConnectWalletModal.EnableTrading",
  });

  return (
    <>
      <HeaderSubText>
        {t("enable_trading_desc", {
          chain: ID_TO_CHAINS[supportedChainId],
          appName: getAppShortName(),
        })}
        {checkReferralData?.is_referrable ? (
          <ReferralCodeText>
            {t("registering_with_refcode")} <span>{referralCode}</span>.
          </ReferralCodeText>
        ) : null}
      </HeaderSubText>
      <Padding>
        {inviteRequired ? (
          <InviteCodeWrapper>
            <InviteCodeLabel>Invite code</InviteCodeLabel>
            <Input
              type="text"
              value={inviteCode || ""}
              placeholder="Enter invite code"
              onChange={(event) => setInviteCode?.(event.target.value)}
            />
          </InviteCodeWrapper>
        ) : null}
        <RememberCheckbox>
          <Checkbox
            type="outline"
            title={t("remember_me")}
            checked={isRememberMeChecked}
            onToggle={() => setRememberMe(!isRememberMeChecked)}
          />
          <TooltipExplanation
            title={t("remember_me")}
            explanation={t("remember_me_desc", {
              days: SIGNING_KEY_TTL.remembered.days,
              hours: SIGNING_KEY_TTL.session.hours,
            })}
            renderContent={({ ref, ...triggerHandler }) => (
              <RememberMeTooltipWrapper ref={ref} {...triggerHandler}>
                <Info />
              </RememberMeTooltipWrapper>
            )}
          />
        </RememberCheckbox>
        <HeaderSubText data-testid="remember-me-duration">
          {isRememberMeChecked
            ? t("remember_me_on", { count: SIGNING_KEY_TTL.remembered.days })
            : t("remember_me_off", { count: SIGNING_KEY_TTL.session.hours })}
        </HeaderSubText>
      </Padding>
    </>
  );
}
export default EnableTrading;
